var React = require('react');

function IconDocument (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M50 0C22.4 0 0 22.4 0 50s22.4 50 50 50 50-22.4 50-50S77.6 0 50 0zm0 96.3C24.5 96.3 3.7 75.5 3.7 50 3.7 24.5 24.5 3.7 50 3.7c25.5 0 46.3 20.8 46.3 46.3 0 25.5-20.8 46.3-46.3 46.3z","key":0}),React.createElement("path",{"stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"4","d":"M55.625 24h-20.5A5.125 5.125 0 0030 29.125v41a5.125 5.125 0 005.125 5.125h30.75A5.125 5.125 0 0071 70.125v-30.75L55.625 24z","key":1}),React.createElement("path",{"stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"4","d":"M55.625 24v15.375H71M60.75 52.188h-20.5M60.75 62.438h-20.5M45.375 41.938H40.25","key":2})]);
}

IconDocument.defaultProps = {"fill":"none","viewBox":"0 0 100 100"};

module.exports = IconDocument;

IconDocument.default = IconDocument;
